<div class="mark-purchase-request-modal">
    <p class="subtitle" i18n>
        You are marking the following purchase request as
        <em> {{ newStatusI18n }}: </em>
    </p>
    <data-card>
        <p>
            <label class="purchase-request-id-label">Purchase Request ID:</label>
            {{ purchaseRequest.id }}
        </p>
    </data-card>
    <div *ngIf="!purchaseRequest.soldDate" class="date-select-field">
        <label i18n>Input the date the request was sold:</label>
        <lsq-date-select
            class="date-select-input"
            label=""
            placeholder="MM/DD/YYYY"
            [ngModel]="newDate"
            (ngModelChange)="onDateChange($event)"
        >
        </lsq-date-select>
    </div>
</div>
